import { useAppDispatch } from 'reduxTyped'
import { closeConnectChannelModal, openConnectChannelModal } from 'common/core/actions/uiActions'

import { ChannelType, ConnectChannelModalSource } from '../constants/ChannelType'

export const useConnectChannelModal = () => {
  const dispatch = useAppDispatch()

  return {
    close: () => dispatch(closeConnectChannelModal()),
    open: (channels: ChannelType[], source?: ConnectChannelModalSource) =>
      dispatch(openConnectChannelModal(channels, source)),
  }
}
